/**
 * Search Illustrations Index
 * 
 * Centralized export for all search state illustrations
 */

import TVNoSignal from './TVNoSignal';

/**
 * Get a random illustration component
 * @returns {React.Component} Random illustration component
 */
export const getRandomIllustration = () => {
    // Only TVNoSignal for now
    return TVNoSignal;
};

/**
 * Get all illustration components
 * @returns {Array<React.Component>} Array of all illustration components
 */
export const getAllIllustrations = () => {
    return [
        TVNoSignal
    ];
};

export { TVNoSignal };

